import { NgModule } from '@angular/core';
import { getFeatureEnabledGuard } from '@capital-access/common/feature-toggle';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { AlertsNavConfigProvider } from './alerts-nav-config.provider';

export const loadModule = () => import('@capital-access/alerts/client').then(m => m.AlertsClientModule);

// @dynamic
@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: 'data-alerts',
          loadChildren: loadModule,
          canActivate: [getFeatureEnabledGuard('CA-Alerts')]
        }
      ]
    })
  ],
  providers: [provideNavConfig(AlertsNavConfigProvider)]
})
export class AlertsClientLazyModule {}
